
import { parseAttribute } from '@utils/gw'

export const BREAKPOINT_KEY_SEGMENTS = ['breakpoint', 'bp', 'media', 'mq']
export const KEY_PATTERNS = {
  breakpoint: new RegExp(`^(?:${BREAKPOINT_KEY_SEGMENTS.join('|')})-|-(?:${BREAKPOINT_KEY_SEGMENTS.join('|')})$`),
}

export const VALUE_PATTERNS = {
  boolean: /^(true|false)$/,
  number: /^\d+(\.\d+)?$/,
  array: /^\[(.*)\]$/,
  arrayString: /^(?:[\w\- ]+, ?)+[\w\- ]+,?$/,
  object: /^\{(?:.*?\:.*?,?\s*)+\}$/,
}

export const MEDIA_ASPECT_RATIO_ALIASES = {
  landscape: '16/9',
  portrait: '5/7',
  square: '1/1',
}

export const MEDIA_ASPECT_RATIO_DELIMITERS = ['/', ':']

export const VALUE_PARSERS = {
  boolean: value => value === 'true',
  number: value => Number(value),
  array: value => JSON.parse(value),
  arrayString: value => value.split(',').map(item => parseAttribute(item.trim())),
  object: value => JSON.parse(value),
  // TODO: Test
  // breakpoint: value => {
  //   if (typeof value === 'string') return token('breakpoint', 'min', value) ?? value
  //   if (typeof value === 'object') return generateMediaQuery(value)
  //   if (typeof value === 'number') return generateMediaQuery({ 'min-width': value })
  //   return value ?? false
  // },
}

export const MEDIA_QUERY_PROPERTY_ALIASES = {
  min: 'min-width',
  max: 'max-width',
}

export const VIEW_CART_PARAM = 'viewcart'

// Add link selectors to exclude from automatic anchor initialization
export const EXCLUDED_ANCHOR_LINKS = ['#recover', '#login', '#MainContent', '#my-account']
